// Brand constants for itj.dev
export const BRAND = {
  // Company Information
  COMPANY_NAME: 'itj.dev',
  COMPANY_NAME_DISPLAY: 'itj.dev', // For display purposes
  
  // Contact Information
  EMAIL: 'hello@itj.dev',
  
  // Social Media
  GITHUB_URL: 'https://github.com/truskul',
  LINKEDIN_URL: 'https://linkedin.com/in/jakub-dudzinski',
  
  // Website Information
  DOMAIN: 'itj.dev',
  WEBSITE_URL: 'https://itj.dev',
  
  // Professional Information
  FOUNDER_NAME: 'Jakub Dudziński',
  TITLE: 'Senior DevOps Engineer',
  
  // SEO & Meta
  TAGLINE: 'Tech that works',
  DESCRIPTION: 'End-to-end technology problem solving. Cloud & DevOps - infrastructure that never fails, Web & Mobile Development - applications users love, AI Integration - automation that saves time.',
  
  // Copyright
  COPYRIGHT_YEAR: new Date().getFullYear(),
  
  // Colors (for reference)
  COLORS: {
    PRIMARY: '#20b2aa',
    SECONDARY: '#aa96da',
    AZURE: '#0078d4',
    KUBERNETES: '#326ce5'
  }
} as const;

// Email templates
export const EMAIL_SUBJECTS = {
  GENERAL_INQUIRY: (companyName: string) => `Inquiry about ${companyName} services`,
  DEVOPS_INQUIRY: (service: string, name: string) => `New DevOps Inquiry: ${service} - ${name}`,
  DEVOPS_INQUIRY_PL: (service: string, name: string) => `Nowe zapytanie DevOps: ${service} - ${name}`
} as const;

// Utility functions
export const getBrandEmail = (subject?: string, body?: string) => {
  const params = new URLSearchParams();
  if (subject) params.append('subject', subject);
  if (body) params.append('body', body);
  
  return `mailto:${BRAND.EMAIL}${params.toString() ? '?' + params.toString() : ''}`;
};

export const getCopyrightText = (language: 'pl' | 'en' = 'en') => {
  const rightsText = language === 'pl' ? 'Wszystkie prawa zastrzeżone.' : 'All rights reserved.';
  return `© ${BRAND.COPYRIGHT_YEAR} ${BRAND.COMPANY_NAME}. ${rightsText}`;
};

// Meta tag utilities
export const getMetaTags = (language: 'pl' | 'en' = 'en') => {
  const isPolish = language === 'pl';
  
  return {
    title: isPolish 
      ? `${BRAND.COMPANY_NAME} - Technologia, która działa | Cloud & DevOps, Web & Mobile, AI Integration`
      : `${BRAND.COMPANY_NAME} - ${BRAND.TAGLINE} | Cloud & DevOps, Web & Mobile, AI Integration`,
    description: isPolish
      ? `${BRAND.COMPANY_NAME} - Technologia, która działa. Kompleksowe rozwiązywanie problemów technologicznych. Cloud & DevOps - infrastruktura, która nigdy nie zawodzi, Web & Mobile Development - aplikacje, które użytkownicy uwielbiają, AI Integration - automatyzacja, która oszczędza czas.`
      : `${BRAND.COMPANY_NAME} - ${BRAND.TAGLINE}. ${BRAND.DESCRIPTION}`,
    url: BRAND.WEBSITE_URL,
    siteName: BRAND.COMPANY_NAME,
    image: `${BRAND.WEBSITE_URL}/og-image.jpg`,
    twitterImage: `${BRAND.WEBSITE_URL}/twitter-image.jpg`,
    logo: `${BRAND.WEBSITE_URL}/logo.png`
  };
};
